import React, {Component} from 'react'
import Select from '../Select'
import PropTypes from 'prop-types'
import locales from '../../../../locales'

class CountrySelect extends Component {

  createCountryOptions() {
    const options = []
    for (const countryCode in this.props.countries) {
      if (this.props.countries.hasOwnProperty(countryCode)) {
        options.push(
          {
            label: this.getLocalizedCountryName(this.props.countries[countryCode]),
            value: countryCode
          }
        )
      }
    }
    return options.sort((a, b) => {
      return new Intl.Collator(this.props.language).compare(a.label, b.label)
    })
  }

  getLocalizedCountryName(country) {
    const locale = locales.find((locale) => locale.shortLocale === this.props.language).locale
    if (country.name) {
      if (locale && country.name.localized_strings[locale]) {
        return country.name.localized_strings[locale]
      }
      if (country.name.default) {
        return country.name.default
      }
    }
    return ''
  }

  render() {
    return (
      <Select onChange={this.props.onChange}
              options={this.createCountryOptions()}
              label={this.props.label}
              valid={this.props.valid}
              round={this.props.round}
              message={this.props.message}
              selected={this.props.selected}
              required={this.props.required}
              placeholder={this.props.placeholder}
      />
    )
  }
}

CountrySelect.defaultProps = {
  required: false,
  placeholder: '',
}

CountrySelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  countries: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
  label: PropTypes.string,
  selected: PropTypes.string,
  valid: PropTypes.bool,
  round: PropTypes.bool,
  message: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string
}

export default CountrySelect
